export function removeTrailingSlash(str: string): string {
    if (!str) {
        return str;
    }
    return str.endsWith('/') ? str.slice(0, -1) : str;
}
